import { render, staticRenderFns } from "./BanksList.vue?vue&type=template&id=534c3822&scoped=true"
import script from "./BanksList.vue?vue&type=script&lang=js"
export * from "./BanksList.vue?vue&type=script&lang=js"
import style0 from "./BanksList.vue?vue&type=style&index=0&id=534c3822&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "534c3822",
  null
  
)

export default component.exports